import { CheckoutContext } from '@/context/CheckoutContext';
import { CheckoutRedirectOrderStatus } from '@/constants/checkoutRedirectOrderStatus';
import { getEventDataForSdkEvents } from '@/utils/eventDataBuilder';
import { getRedirectUrlWithEventParams } from '@/utils/redirect';
import { useContext, useMemo } from 'react';
import { resolveIsRedirectFlow } from '@/utils/checkoutMode';
import { getRedirectLinkFromUrlParams } from '@/utils/params';

export function useRedirectLink(orderStatus: CheckoutRedirectOrderStatus = CheckoutRedirectOrderStatus.SUCCESS) {
  const context = useContext(CheckoutContext);
  const orderData = context.successScreen?.orderData;
  const orderId = context.redirectPayment?.orderId ?? context.orderId;
  const paymentAttempt = context.paymentAttempt;
  const isRedirectFlow = resolveIsRedirectFlow(context.checkoutConfiguration);
  const redirectUrl = getRedirectLinkFromUrlParams() || context.redirectLink;

  const fullyRedirectLink = useMemo(() => {
    if (isRedirectFlow && redirectUrl && orderId) {
      return getRedirectUrlWithEventParams(redirectUrl, orderStatus, {
        ...getEventDataForSdkEvents(context, paymentAttempt),
        orderId,
        purchaseId: orderData?.publisherPurchaseId,
      });
    }
    return null;
  }, [context, isRedirectFlow, redirectUrl, orderData?.publisherPurchaseId, orderId, orderStatus, paymentAttempt]);

  return { fullyRedirectLink };
}
